export default "__VITE_ASSET__BjvnUJpv__"